import { useCallback, useState } from 'react';

function useSearchForm(callback, afterCallback, initialData) {
    const [isPending, setIsPending] = useState(false);
    const [data, setData] = useState(initialData?.data || {});
    const [isSuccessful, setIsSuccessful] = useState(false);
    const [fields, setFields] = useState({searchText: initialData?.searchText || ''});
    const [errors, setErrors] = useState({searchText: '', form: ''});

    const changeField = useCallback((name, value) => {
        if (errors[name] || errors.form) {
            setErrors(prevState => ({...prevState, [name]: '', form: ''}));
        }

        setFields(prevState => ({...prevState, [name]: value}));
    }, [errors]);

    const clearForm = () => {
        setData(initialData?.data || {});
        setIsSuccessful(false);
    };

    const submitForm = async (e) => {
        e?.preventDefault();

        try {
            setIsPending(true);
            setIsSuccessful(false);
            setErrors({searchText: '', form: ''});
            setData({});

            const response = await callback(fields.searchText);

            afterCallback?.();

            if (response) {
                setErrors({searchText: '', form: ''});
                setData(response);
                setIsSuccessful(true);
            } else {
                setErrors(prevState => ({...prevState, form: 'Repeat please request'}));
            }
        } catch (error) {
            setData({});
            setErrors(prevState => ({...prevState, form: error?.message || 'Fail'}));
        } finally {
            setIsPending(false);
        }
    };

    return {
        fields,
        errors,
        isPending,
        data,
        isSuccessful,
        submitForm,
        clearForm,
        changeField
    }
};

export {
    useSearchForm
};
